import { Button } from '@effizency/efz-design-system';
import type { ReactNode } from 'react';

// Illustrations
import { ReactComponent as BackgroundBottom } from 'assets/images/errors/bottom-graph.svg';
import { ReactComponent as BackgroundLeft } from 'assets/images/errors/left-graph.svg';
import { ReactComponent as BackgroundRight } from 'assets/images/errors/right-graph.svg';

interface IErrorPageProps {
    /** Shown over the text. */
    illustration?: ReactNode;
    title: ReactNode;
    description?: ReactNode;
    buttonLabel: ReactNode;
    onButtonClick: () => void;
}

/** The page the app shows when a page is missing or not allowed: what happened, and a button out of it. */
const ErrorPage = ({ illustration, title, description, buttonLabel, onButtonClick }: IErrorPageProps) => (
    <div className="content-wrapper-fluid page404-container">
        <div className="ornaments-svg">
            <div className="ornament-left">
                <BackgroundLeft />
            </div>
            <div className="ornament-bottom-container">
                <div className="ornament-bottom">
                    <BackgroundBottom />
                </div>
            </div>
            <div className="ornament-right">
                <BackgroundRight />
            </div>
        </div>

        <section className="page404-content-container">
            <div className="content-container">
                <div className="page404-content-image">{illustration}</div>
                <div className="page404-content-text">
                    <h3>{title}</h3>
                    {!!description && <span>{description}</span>}
                </div>
            </div>
            <div>
                <Button variant="primary" onClick={onButtonClick} dataTestId="error-page-button">
                    {buttonLabel}
                </Button>
            </div>
        </section>
    </div>
);

export default ErrorPage;
